module.exports = __webpack_public_path__ + "img/line-number-03.177e0e1f.svg";